const SOLVED_SQUARE = "\u{1F7E6}"; // 🟦. level solved by the player
const FAILED_SQUARE = "\u{2B1C}"; // ⬜. level given away after running out of tries

// One boolean per guessable level (pyramidOfWords[0] is the given starting
// word and is never guessed, so levels start at index 1). A level counts as
// "solved by the player" if any of its tried-out words matched perfectly.
// if it was instead auto-revealed (level/REVEAL_AND_ADVANCE), no fully
// correct entry was ever recorded for it, so it stays false here even though
// the game moved the player past it.
export function getLevelSolvedFlags(pyramidOfWords, triedOutWords) {
	if (!Array.isArray(pyramidOfWords) || pyramidOfWords.length <= 1) {
		return [];
	}

	const attempts = Array.isArray(triedOutWords) ? triedOutWords : [];

	return pyramidOfWords.slice(1).map((_, wordIndex) => {
		const levelIndex = wordIndex + 1;

		return attempts.some(
			(attempt) =>
				attempt.level === levelIndex && !attempt.tilesMap.includes("w")
		);
	});
}

export function getLevelResultSquares(pyramidOfWords, triedOutWords) {
	return getLevelSolvedFlags(pyramidOfWords, triedOutWords).map((solved) =>
		solved ? SOLVED_SQUARE : FAILED_SQUARE
	);
}

// How many levels the player actually solved themselves. NOT bumped for
// levels the game auto-completed after the player ran out of tries. Used for
// the ResultDialog's "You've got X out of N" copy and its score heading.
export function getNumberOfLevelsSolvedByPlayer(pyramidOfWords, triedOutWords) {
	return getLevelSolvedFlags(pyramidOfWords, triedOutWords).filter(Boolean)
		.length;
}

export function buildPirmydShareText({
	dayNumber,
	pyramidOfWords,
	triedOutWords,
}) {
	const squares = getLevelResultSquares(pyramidOfWords, triedOutWords).join(
		""
	);
	const dayLabel = dayNumber ? `#${dayNumber} ` : "";

	return `Pirmyd ${dayLabel}${squares}. https://wordfinder.yourdictionary.com/play/pirmyd/`;
}
